document.querySelectorAll('.sg-tab').forEach(function(tab) {
  tab.addEventListener('click', function() {

    // Saare tabs se active hata do
    document.querySelectorAll('.sg-tab').forEach(function(t) {
      t.classList.remove('active');
    });

    // Saare panels hide karo
    document.querySelectorAll('.sg-panel').forEach(function(p) {
      p.classList.remove('active');
    });

    // Is tab ko active karo
    this.classList.add('active');

    // Target panel show karo
    document.getElementById(this.dataset.target).classList.add('active');
  });
});

/*-----------Product-slider-----------------*/

(function () {
  function initVerticalThumbArrows() {
    if (window.innerWidth < 750) return; // sirf tablet/desktop pe kaam karega

    document.querySelectorAll('.thumbnail-slider').forEach(function (slider) {
      if (slider.dataset.verticalArrowsBound) return;

      var list = slider.querySelector('.thumbnail-list');
      var prevBtn = slider.querySelector('.slider-button--prev');
      var nextBtn = slider.querySelector('.slider-button--next');
      if (!list || !prevBtn || !nextBtn) return;

      slider.dataset.verticalArrowsBound = 'true';

      var firstItem = list.querySelector('.thumbnail-list__item');
      var step = firstItem ? firstItem.offsetHeight + 7 : 124;

      // Dawn baar-baar disabled attribute laga deta hai — usko turant hatao
      function forceEnable(btn) {
        if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
      }
      forceEnable(prevBtn);
      forceEnable(nextBtn);

      var observer = new MutationObserver(function () {
        forceEnable(prevBtn);
        forceEnable(nextBtn);
      });
      observer.observe(prevBtn, { attributes: true, attributeFilter: ['disabled'] });
      observer.observe(nextBtn, { attributes: true, attributeFilter: ['disabled'] });

      // Dawn ka horizontal-scroll click logic block karke apna vertical scroll
      prevBtn.addEventListener('click', function (e) {
        if (window.innerWidth < 750) return; // mobile pe Dawn ka default hi chalega
        e.preventDefault();
        e.stopImmediatePropagation();
        list.scrollBy({ top: -step, behavior: 'smooth' });
      }, true);

      nextBtn.addEventListener('click', function (e) {
        if (window.innerWidth < 750) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        list.scrollBy({ top: step, behavior: 'smooth' });
      }, true);
    });
  }

  window.addEventListener('load', initVerticalThumbArrows);
  window.addEventListener('resize', initVerticalThumbArrows);
})();